// extracted by mini-css-extract-plugin
export default {"root":"ImagePlaceholder_root__sUaaW","icon":"ImagePlaceholder_icon__ZFpys"};